import { DOCUMENT, isPlatformServer } from '@angular/common';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { lucideIcons } from './lucide';

/**
 * Material-free provider. Injects the Lucide sprite as a hidden inline
 * <svg> at the start of <body> so <m-icon name="..."> can resolve it via
 * <use href="#name">. Runs only in the browser (skipped under SSR).
 */
export const provideMIcons = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      if (isPlatformServer(inject(PLATFORM_ID))) return;

      const doc = inject(DOCUMENT);
      const container = doc.createElement('div');
      container.innerHTML = lucideIcons;
      const svg = container.querySelector('svg');
      if (!svg) return;

      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('data-m-icon-sprite', '');
      const style = svg.style;
      style.position = 'absolute';
      style.width = '0';
      style.height = '0';
      style.overflow = 'hidden';
      doc.body.prepend(svg);
    }),
  ]);
